var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.676,
    height: 12.676,
    viewBox: "0 0 12.676 12.676",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.338,2a6.338,6.338,0,1,0,6.338,6.338A6.338,6.338,0,0,0,8.338,2Zm.634,9.507H7.7V7.7H8.972Zm0-5.07H7.7V5.169H8.972Z",
    transform: "translate(-2 -2)",
    fill: "#b9bdc3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGrey);
export default __webpack_public_path__ + "static/media/info-grey.ac6e03c96f29dc86e5849e1a4b811ed3.svg";
export { ForwardRef as ReactComponent };